import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

@Component({
  selector: 'app-admin-microsoft-graph',
  templateUrl: './microsoft-graph.component.html',
  styleUrls: ['./microsoft-graph.component.scss'],
})
export class AdminMicrosoftGraphComponent implements OnInit {
  sajatIntezmeny: any;
  loading = false;
  saving = false;

  settings = {
    enabled: false,
    tenant_id: '',
    client_id: '',
    client_secret: '',
    has_client_secret: false,
  };

  constructor(private data: DataService, private http: HttpClient) {}

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.loadSettings();
  }

  private intezmenyPath(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  loadSettings() {
    if (!this.sajatIntezmeny?.intezmenyId) return;

    this.loading = true;
    this.http.get<any>('/api/microsoft-graph/beallitas/' + this.intezmenyPath()).subscribe({
      next: (response) => {
        this.settings = {
          enabled: !!response?.enabled,
          tenant_id: response?.tenant_id || '',
          client_id: response?.client_id || '',
          client_secret: '',
          has_client_secret: !!response?.has_client_secret,
        };
        this.loading = false;
      },
      error: (error) => {
        console.error('Microsoft Graph beállítás betöltési hiba:', error);
        this.loading = false;
        this.data.sendToast('Nem sikerült betölteni a Microsoft Graph beállításokat.', 'error');
      },
    });
  }

  saveSettings() {
    if (!this.sajatIntezmeny?.intezmenyId) return;

    this.saving = true;
    this.http.put<any>('/api/microsoft-graph/beallitas/' + this.intezmenyPath(), this.settings).subscribe({
      next: (response) => {
        this.settings = {
          enabled: !!response?.enabled,
          tenant_id: response?.tenant_id || '',
          client_id: response?.client_id || '',
          client_secret: '',
          has_client_secret: !!response?.has_client_secret,
        };
        this.saving = false;
        this.data.sendToast('A Microsoft Graph profilkép beállításai mentve.', 'success');
      },
      error: (error) => {
        console.error('Microsoft Graph beállítás mentési hiba:', error);
        this.saving = false;
        this.data.sendToast('Nem sikerült menteni a Microsoft Graph beállításokat.', 'error');
      },
    });
  }
}
